import { render, staticRenderFns } from "./GetGradualMessages.vue?vue&type=template&id=48cf9ea7&"
import script from "./GetGradualMessages.vue?vue&type=script&lang=js&"
export * from "./GetGradualMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports